import { ActionCalculation } from "./ActionCalculation/ActionCalculation";
import { ActionEditLayoutWithStickyInfo } from "./ActionEditLayoutWithStickyInfo";

export const EditPlanningProperties = () => {
    return (
        <ActionEditLayoutWithStickyInfo>
            <ActionCalculation />
        </ActionEditLayoutWithStickyInfo>
    );
};
